import { findMessagesForInvestibleId, titleText } from '../../../utils/messageUtils';
import { getInvestible } from '../../../contexts/InvestibesContext/investiblesContextHelper';
import { getMarketInfo } from '../../../utils/userFunctions';
import { getMarket } from '../../../contexts/MarketsContext/marketsContextHelper';
import {
  getComment,
  getCommentRoot,
  getInvestibleComments,
  isDesignCapsule
} from '../../../contexts/CommentsContext/commentsContextHelper';
import { stripHTML, transformTicketCode } from '../../../utils/stringFunctions';
import { formCommentLink, formMarketLink, formWizardLink, navigate,
  preventDefaultAndProp } from '../../../utils/marketIdPathFunctions';
import { calculateTitleExpansionPanel } from './InboxExpansionPanel';
import WorkListItem from './WorkListItem';
import { getNotificationDestination } from '../../../utils/notificationNavigation';
import BlockedNotificationPanel from './BlockedNotificationPanel';
import React, { useContext, useEffect } from 'react';
import { CommentsContext } from '../../../contexts/CommentsContext/CommentsContext';
import { InvestiblesContext } from '../../../contexts/InvestibesContext/InvestiblesContext';
import { MarketsContext } from '../../../contexts/MarketsContext/MarketsContext';
import {
  Assignment,
  Block,
  CalendarToday,
  Done,
  PersonAddOutlined,
  ReportOutlined,
  Schedule
} from '@material-ui/icons';
import Quiz from '../../../components/CustomChip/Quiz';
import { useIntl } from 'react-intl';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { getFullStage, getInReviewStage } from '../../../contexts/MarketStagesContext/marketStagesContextHelper';
import { MarketStagesContext } from '../../../contexts/MarketStagesContext/MarketStagesContext';
import { getMessageId, isInInbox,
  messageIsSynced } from '../../../contexts/NotificationsContext/notificationsContextHelper';
import { NotificationsContext } from '../../../contexts/NotificationsContext/NotificationsContext';
import { OperationInProgressContext } from '../../../contexts/OperationInProgressContext/OperationInProgressContext';
import { deleteOrDehilightMessages } from '../../../api/users';
import { useHistory } from 'react-router';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import { MarketPresencesContext } from '../../../contexts/MarketPresencesContext/MarketPresencesContext';
import ThumbsUpDownIcon from '@material-ui/icons/ThumbsUpDown';
import QuestionIcon from '@material-ui/icons/ContactSupport';
import RateReviewIcon from '@material-ui/icons/RateReview';
import LightbulbOutlined from '../../../components/CustomChip/LightbulbOutlined';
import { DECISION_TYPE, INITIATIVE_TYPE, JOB_STAGE_WIZARD_TYPE, PLANNING_TYPE } from '../../../constants/markets';
import ReplyIcon from '@material-ui/icons/Reply';
import ListAltIcon from '@material-ui/icons/ListAlt';
import { getMarketPresences } from '../../../contexts/MarketPresencesContext/marketPresencesHelper';
import { NOT_FULLY_VOTED_TYPE, POKED, UNREAD_JOB_APPROVAL_REQUEST } from '../../../constants/notifications';
import { MarketGroupsContext } from '../../../contexts/MarketGroupsContext/MarketGroupsContext';
import _ from 'lodash';
import Approval from '../../../components/CustomChip/Approval';
import EditNote from '../../../components/CustomChip/EditNote';
import { ISSUE_TYPE, QUESTION_TYPE, REPORT_TYPE, SUGGEST_CHANGE_TYPE, TODO_TYPE } from '../../../constants/comments';
import { stageChangeInvestible } from '../../../api/investibles';
import { onInvestibleStageChange } from '../../../utils/investibleFunctions';

function getPriorityIcon(message, isAssigned, isMentioned, originalComment) {
  const { level, link_type: linkType, is_highlighted: isHighlighted, decision_investible_id: decisionInvestibleId,
    market_type: marketType, alert_type: alertType, poked_list: pokedList } = message;
  let Icon = Quiz;
  if (!_.isEmpty(message.edit_list)) {
    Icon = EditNote;
  }
  if (message.type === 'UNREAD_VOTE') {
    Icon = Done;
  }
  if (isAssigned) {
    Icon = Assignment;
  }
  if (message.type?.includes('REVIEW') && !isAssigned) {
    Icon = RateReviewIcon;
  }
  if (['UNREAD_MOVE_REPORT', 'REPORT_REQUIRED'].includes(message.type)) {
    Icon = Schedule;
  }
  if (['UNASSIGNED', 'UNREAD_GROUP'].includes(message.type) || (message.type === 'UNREAD_REVIEWABLE'
      && 'MARKET_TODO' === linkType)) {
    Icon = PersonAddOutlined;
  }
  if (message.type === 'INVESTIBLE_SUBMITTED') {
    Icon = ThumbsUpDownIcon;
  }
  if (message.type === 'REQUEST_WORK') {
    Icon = Assignment;
  }
  if ([NOT_FULLY_VOTED_TYPE, UNREAD_JOB_APPROVAL_REQUEST].includes(message.type)) {
    if (marketType === INITIATIVE_TYPE) {
      Icon = LightbulbOutlined;
    } else if (marketType === DECISION_TYPE || decisionInvestibleId) {
      Icon = QuestionIcon;
    } else {
      Icon = Approval;
    }
  }
  if (['ISSUE', 'UNREAD_COMMENT'].includes(message.type)) {
    if (linkType.includes('QUESTION')||originalComment?.comment_type === QUESTION_TYPE) {
      Icon = QuestionIcon;
    } else if (linkType.includes('SUGGEST')||originalComment?.comment_type === SUGGEST_CHANGE_TYPE) {
      Icon = LightbulbOutlined;
    } else if ('INVESTIBLE_REVIEW' === linkType) {
      Icon = ListAltIcon;
    // B-all-559: match the dedicated AI view-note route instead of showing the blocker icon.
    } else if (message.alert_type === 'AI_GENERATED' && linkType === 'MARKET_COMMENT' &&
      originalComment?.comment_type === REPORT_TYPE && !originalComment.investible_id) {
      Icon = EditNote;
    } else {
      Icon = Block;
    }
  }
  if (message.type === 'UNREAD_REPLY') {
    Icon = ReplyIcon;
  }

  if (message.type === 'REPLY_MENTION') {
    Icon = ReportOutlined;
  }

  if (message.type === 'UNREAD_ESTIMATE') {
    Icon = CalendarToday;
  }

  if (alertType === POKED || !_.isEmpty(pokedList) || isMentioned) {
    Icon = ReportOutlined;
  }
  if (isDesignCapsule(originalComment)) {
    Icon = RateReviewIcon;
  }

  if (!isHighlighted) {
    return <Icon style={{fontSize: 24, color: '#706f6f'}}/>;
  }
  switch (level) {
    case 'RED':
      return <Icon style={{fontSize: 24, color: '#E85757'}}/>;
    case 'YELLOW':
      return <Icon style={{fontSize: 24, color: '#ffc61a'}}/>;
    case 'BLUE':
      return <Icon style={{fontSize: 24, color: '#2D9CDB'}}/>;
    default:
      return undefined;
  }
}

function InboxRow(props) {
  const { message, checked, determinateDispatch, expansionOpen, isDeletable } = props;
  const intl = useIntl();
  const theme = useTheme();
  const history = useHistory();
  const mobileLayout = useMediaQuery(theme.breakpoints.down('sm'));
  const [commentState, commentsDispatch] = useContext(CommentsContext);
  const [investiblesState, investiblesDispatch] = useContext(InvestiblesContext);
  const [marketsState] = useContext(MarketsContext);
  const [marketStagesState] = useContext(MarketStagesContext);
  const [marketPresencesState, marketPresencesDispatch] = useContext(MarketPresencesContext);
  const [groupState] = useContext(MarketGroupsContext);
  const [messagesState, messagesDispatch] = useContext(NotificationsContext);
  const [, setOperationRunning] = useContext(OperationInProgressContext);
  const { investible_id: investibleId, investible_name: investibleName, updated_at: updatedAt,
    market_name: marketName, type_object_id: typeObjectId, market_id: marketId, comment_id: commentId,
    comment_market_id: commentMarketId, is_highlighted: isHighlighted, type: messageType } = message;
  const inv = getInvestible(investiblesState, investibleId);
  const marketInfo = getMarketInfo(inv, marketId) || {};
  const { accepted, assigned, stage } = marketInfo;
  const marketPresences = getMarketPresences(marketPresencesState, marketId) || [];
  const myPresence = marketPresences.find((presence) => presence.current_user);
  const userId = myPresence?.id;
  const isAssigned = (assigned || []).includes(userId);
  const isPendingAcceptance = isAssigned && !(accepted || []).includes(userId);
  const market = getMarket(marketsState, marketId) || {};
  const item = {
    market: market.name || marketName,
    investible: messageType === 'UNREAD_REPLY' ? undefined : (inv ? inv.investible.name : investibleName),
    read: !isHighlighted,
    date: intl.formatDate(updatedAt),
    isDeletable,
    isAssigned,
    isPendingAcceptance,
    message,
    isNotSynced: !messageIsSynced(message, marketsState, marketPresencesState, commentState, investiblesState,
      groupState)
  }
  // A direct inbox URL can request expansion before its named comment arrives. Keep it in the
  // ordinary grey row branch until the same sync predicate says the wizard can be classified.
  const safeExpansionOpen = expansionOpen && !item.isNotSynced;
  const destination = !item.isNotSynced && getNotificationDestination(message, commentState, marketsState);
  const destinationUrl = destination?.url;
  const { id: notificationId, marketId: notificationMarketId, commentId: notificationCommentId } =
    destination?.notification || {};
  useEffect(() => {
    if (safeExpansionOpen && destinationUrl) {
      navigate(history, destinationUrl, false, true, {
        notification: { id: notificationId, marketId: notificationMarketId, commentId: notificationCommentId }
      });
    }
  }, [safeExpansionOpen, destinationUrl, notificationId, notificationMarketId,
    notificationCommentId, history]);
  item.destination = destination;
  // T-all-2445: rows associated with a job carry its condensed code; hovering it reveals the job name
  if (marketInfo.ticket_code) {
    item.ticketCode = transformTicketCode(decodeURI(marketInfo.ticket_code));
    item.ticketName = inv ? inv.investible.name : investibleName;
  }

  const fullStage = getFullStage(marketStagesState, marketId, stage) || {};
  // C-all-1372: per job sweep controls on hover, following the existing trash can pattern (S-1
  // of Q-all-368). Clearing is this user's inbox only (Q-all-366). Open tasks still confirm
  // before the move; the finished-work prompt is not part of this (C-all-2248).
  if (!_.isEmpty(inv) && market.market_type === PLANNING_TYPE && !_.isEmpty(assigned)) {
    const inReviewStage = getInReviewStage(marketStagesState, marketId) || {};
    const jobSweepActions = [{
      translationId: 'inboxClearJob',
      icon: <DeleteSweepIcon />,
      onClick: (event) => {
        preventDefaultAndProp(event);
        setOperationRunning(true);
        return deleteOrDehilightMessages(findMessagesForInvestibleId(investibleId, messagesState.messages)
          .filter((jobMessage) => isInInbox(jobMessage)), messagesDispatch, true, false, true)
          .finally(() => setOperationRunning(false));
      }
    }];
    if (stage !== inReviewStage.id) {
      const wizardLink = `${formWizardLink(JOB_STAGE_WIZARD_TYPE, marketId,
        investibleId)}&stageId=${inReviewStage.id}`;
      function moveInboxJobToReviewable(doClear) {
        const investibleComments = getInvestibleComments(investibleId, marketId, commentState);
        const mustResolveComments = investibleComments.filter((comment) => !comment.resolved && (
          [ISSUE_TYPE, TODO_TYPE].includes(comment.comment_type) ||
          ([QUESTION_TYPE, SUGGEST_CHANGE_TYPE].includes(comment.comment_type) &&
            (assigned || []).includes(comment.created_by))));
        if (!_.isEmpty(mustResolveComments)) {
          const clearSuffix = doClear ? '&clearNotifications=true' : '';
          navigate(history, `${wizardLink}${clearSuffix}`);
          return;
        }
        setOperationRunning(true);
        return stageChangeInvestible({
          marketId,
          investibleId,
          stageInfo: {
            current_stage_id: stage,
            stage_id: inReviewStage.id,
          },
        }).then((newInv) => {
          onInvestibleStageChange(inReviewStage.id, newInv, investibleId, marketId, commentState,
            commentsDispatch, investiblesDispatch, () => {}, marketStagesState, undefined, fullStage,
            marketPresencesDispatch);
          const clearPromise = doClear ? deleteOrDehilightMessages(
            findMessagesForInvestibleId(investibleId, messagesState.messages)
              .filter((jobMessage) => isInInbox(jobMessage)), messagesDispatch, true, false, true)
            : Promise.resolve(true);
          return clearPromise.then(() => navigate(history, formMarketLink(marketId, marketInfo.group_id)));
        }).finally(() => setOperationRunning(false));
      }
      jobSweepActions.push({
        translationId: 'inboxMoveJobReviewable',
        icon: <DoneAllIcon />,
        onClick: (event) => {
          preventDefaultAndProp(event);
          return moveInboxJobToReviewable(false);
        }
      });
      jobSweepActions.push({
        translationId: 'inboxMoveJobReviewableClear',
        icon: <DoneOutlineIcon />,
        onClick: (event) => {
          preventDefaultAndProp(event);
          return moveInboxJobToReviewable(true);
        }
      });
    }
    item.jobSweepActions = jobSweepActions;
  }
  let rootComment;
  let originalComment;
  let rootCommentLink;
  if (commentId) {
    const { parent_comment_id: inlineParentCommentId, parent_comment_market_id: parentMarketId } = market
    let useMarketId = commentMarketId || marketId;
    let useCommentId = commentId;
    if (inlineParentCommentId) {
      // If there is a top level question always display it instead of lower level comments
      useMarketId = parentMarketId;
      useCommentId = inlineParentCommentId;
    }
    rootComment = getCommentRoot(commentState, useMarketId, useCommentId);
    if (rootComment) {
      rootCommentLink = formCommentLink(useMarketId, rootComment.group_id, rootComment.investible_id,
        rootComment.id);
      if (rootComment.id !== commentId) {
        originalComment = getComment(commentState, commentMarketId || marketId, commentId) || {};
        const comment = stripHTML(originalComment.body);
        if (comment) {
          item.comment = comment;
        }
      } else {
        originalComment = rootComment;
      }
      if (!item.comment) {
        const comment = stripHTML(rootComment.body);
        if (comment) {
          item.comment = comment;
        }
      }
    }
  }
  const isMentioned = originalComment?.mentions?.find((mention) => mention.user_id === userId);
  item.icon = getPriorityIcon(message, isAssigned, isMentioned, originalComment);

  // Per T-all-2391 a resolved root only hides its own notification - thread notifications live on
  // because the backend only removes them for the resolver, and one level deep for the creator
  const isStaleResolved = !!rootComment?.resolved && rootComment?.id === commentId &&
    !typeObjectId?.includes('UNREAD_RESOLVED');
  if (isStaleResolved && !safeExpansionOpen) {
    // Per Q-all-105 notifications out of date with a resolved comment stay hidden in the list view
    console.warn('Notification out of date with a resolved comment')
    console.warn(message);
    return React.Fragment;
  }

  item.title =  titleText(message, mobileLayout, intl, rootComment, userId,
    fullStage.allows_investment, assigned);
  if (messageType === 'USER_POKED') {
    item.market = intl.formatMessage({id: 'pleaseUpgrade'});
  }
  if (isStaleResolved && !destination) {
    // Per Q-all-104 a blocked wizard must explain why and offer dismiss plus a link to the resolved comment
    item.expansionPanel = <BlockedNotificationPanel message={message} explanationId="blockedNotificationResolved"
                                                    commentLink={rootCommentLink}/>;
  } else if (!item.isNotSynced) {
    calculateTitleExpansionPanel({ item, openExpansion: safeExpansionOpen && !destination, intl, rootComment });
    if (safeExpansionOpen && !destination && !item.expansionPanel) {
      item.expansionPanel = <BlockedNotificationPanel message={message}
                                                      explanationId="blockedNotificationGeneric"/>;
    }
  }
  return <WorkListItem key={`inboxRow${getMessageId(message)}`} id={getMessageId(message)} checked={checked}
                       determinateDispatch={determinateDispatch} useSelect={isDeletable} read={!message.is_highlighted}
                       expansionOpen={safeExpansionOpen} {...item} />;
}

export default React.memo(InboxRow);
